import { TaskDrawerMode } from "../types";
import { TaskFormDataModel } from "../models";

interface ICreateTaskDrawerSettings {
  Mode: "create";
  QueueId: string;
  ProjectId: number;
  NamespaceId: string;
  FormData?: TaskFormDataModel;
}
interface ICreateSubtaskDrawerSettings {
  Mode: "create-subtask";
  ParentTaskId: number;
  FormData?: TaskFormDataModel;
}
interface IEditTaskDrawerSettings {
  Mode: "edit";
  TaskId: number;
}
interface ICopyTaskDrawerSettings {
  Mode: "copy";
  TaskId: number;
  QueueId: string;
  ProjectId: number;
  NamespaceId: string;
}

type TaskDrawerSettingsModelConstructor<T extends TaskDrawerMode> = T extends "create"
  ? ICreateTaskDrawerSettings
  : T extends "create-subtask"
    ? ICreateSubtaskDrawerSettings
    : T extends "edit"
      ? IEditTaskDrawerSettings
      : ICopyTaskDrawerSettings;

/**
 * * Модель настроек шторки
 */
export class TaskDrawerSettingsModel<T extends TaskDrawerMode> {
  /**Режим шторки */
  readonly Mode!: T;
  /**ID родительской задачи */
  readonly ParentTaskId: number;
  /**Очередь */
  readonly QueueId: string;
  /**Проект */
  readonly ProjectId: number;
  /**Неймспейс */
  readonly NamespaceId: string;
  /**ID задачи */
  readonly TaskId: number;
  /**Настройки формы */
  readonly FormData?: TaskFormDataModel;

  constructor(obj: TaskDrawerSettingsModelConstructor<T>) {
    Object.assign(this, obj);
  }
}
